export default __webpack_public_path__ + "static/media/attrRect.40df04c2.svg";